export default {
    pcd: "23A",
    pname: "愛知県",
    header: "【愛知県】GoToEatキャンペーン食事券 第4期 Web 受付(第3回)",
    privacy: "23",
    cid: "eaichi",
    unitdetails: "12,000円（1,000円×12枚）／1セット",
    ticketvalue: 12000,
    unitprice: 10000,
    maxunits: 2,
    quantityoptions: [
        {value: "1", text: "1"},
        {value: "2", text: "2"}
    ],
    starttime: "00:00",
    explanation: "本サイトは、【愛知県】GoToEatキャンペーン食事券 第4期 Web 受付(第3回)サイトです。\n【愛知県】GoToEatキャンペーン食事券の申込方法をご案内しますので、以下に同意したうえでメールアドレスのご登録をお願いいたします。",
    emailreceptionsettings: "@funity-rs.jp より、メールを配信いたしますので受信可能に設定してください。\nメールが受信できない場合、お客様の端末にて迷惑メール対策設定が行われている可能性がございます。\n以下の設定方法をご確認頂き、「@funity-rs.jp」からメールを受信出来るように設定をお願い致します。",
    personalinfo: "ご入力いただきました個人情報は、【愛知県】GoToEatキャンペーン食事券の販売のために使用いたします。\n個人情報は、法令に基づく場合を除き、ご本人様の承諾なしに第三者（弊社業務委託先を除く）に提供することはありません。",
    emaillead: "申込完了後のメールアドレスの変更は一切できません。", 
    startdatenotice: {
        header: "◆【愛知県】GoToEatキャンペーン食事券の引換開始日時についての注意事項◆",
        alert: "※お申込は完了しておりません。下記を確認の上、申込を完了して下さい。",
        body: "【愛知県】GoToEatキャンペーン食事券の申込みを頂きありがとうございます。\n\nご登録頂きました、メールアドレス宛に配信されます【愛知県】GoToEatキャンペーン食事券 申込完了通知の内容をご確認の上、お近くのファミリーマートにてお支払い、食事券のお受取りをお願いいたします。",
        danger: "お引換開始は、お申込み日の翌々日0:00からとなります。"  
    },
    completemsg: {
        header: "【愛知県】GoToEatキャンペーン食事券のお申込み｜申込完了",
        body: {
            paragraphs: [
                {parts:[{text: "お申込みを受付しました。"}]},
                {parts:[{text: "ご登録されたメールアドレスに、申込完了通知を送信しました。"}]},
                {parts:[
                    {text: "食事券のお受け取りには、メールに記載の引換票番号が必要になります。"},
                    {text: "メールに記載の入金発券期間にて、ファミリーマートでお支払い、【愛知県】GoToEatキャンペーン食事券のお受け取りをお願いします。"},
                ]},
                {parts:[
                    {text: "いかなる場合でも、メールの再送、引換票番号の再発行はできません。大切に保存ください。"},
                ]},
            ]
        },
        mailnotice: {
            header: "",
            items:[
            ]
        },
        footer: {
            paragraphs: [
                {parts:[]}
            ]
        }
    },
    ie11: true,
    ie11Recommendation: true
};